import axios from "axios";
import { POST_VALIDATE_TOKEN } from "constants/api_constants";
import { clearLocalStorage } from "store/auth/login/saga";
import { getLocalStorageItem } from "./localStorageItems";
const { logoutUser, validateTokenFailure, validateTokenSuccess } = require("store/actions");

export async function validateTokenOnRequest() {
    const token = getLocalStorageItem('token');
    const email = getLocalStorageItem('email');;

    if (token) {
        try {
            const response = await axios.post(`https://backend.elberttech.com${POST_VALIDATE_TOKEN}`, { token, email });
            // const response = await axios.post(`https://enscenter.xyz${POST_VALIDATE_TOKEN}`, { token, email });


            if (response.data != 'Token is valid.') {
                clearLocalStorage();
                logoutUser();
            }
        } catch (error) {
            clearLocalStorage();
            logoutUser();
        }
    }
}
